import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/toaster";
import { Toaster as SonnerToaster } from "./components/ui/sonner";

// Layout
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// import WhatsAppFloat from "./components/WhatsAppFloat"; // Hidden until WhatsApp funnel is configured

// Pages
import Home from "./pages/Home";
import Search from "./pages/Search";
import CarDetails from "./pages/CarDetails";
import Booking from "./pages/Booking";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import UserDashboard from "./pages/UserDashboard";
import MobilitierDashboard from "./pages/MobilitierDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import BecomeMobilitier from "./pages/BecomeMobilitier";
import HowItWorks from "./pages/HowItWorks";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Profile from "./pages/Profile";
import Messages from "./pages/Messages";
import CheckInOut from "./pages/CheckInOut";
import MobilitierOnboarding from "./pages/MobilitierOnboarding";
import AddCar from "./pages/AddCar";
import BookingDetails from "./pages/BookingDetails";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <div className="App flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<Search />} />
                <Route path="/car/:id" element={<CarDetails />} />
                <Route path="/booking/:carId" element={<Booking />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/dashboard" element={<UserDashboard />} />
                <Route path="/mobilitier/dashboard" element={<MobilitierDashboard />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/become-mobilitier" element={<BecomeMobilitier />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/mobilitier/onboarding" element={<MobilitierOnboarding />} />
                <Route path="/mobilitier/add-car" element={<AddCar />} />
                <Route path="/mobilitier/edit-car/:carId" element={<AddCar />} />
                <Route path="/booking-details/:bookingId" element={<BookingDetails />} />
                <Route path="/checkin/:bookingId" element={<CheckInOut type="checkin" />} />
                <Route path="/checkout/:bookingId" element={<CheckInOut type="checkout" />} />
                <Route path="/checkin/:bookingId" element={<CheckInOut type="checkin" />} />
                <Route path="/checkout/:bookingId" element={<CheckInOut type="checkout" />} />
              </Routes>
            </main>
            <Footer />
            {/* <WhatsAppFloat /> — Hidden until WhatsApp funnel is configured */}
            <Toaster />
            <SonnerToaster position="top-right" richColors />
          </div>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
